import { call, put, takeEvery, delay } from 'redux-saga/effects'
import {
  types,
  IDataPollingAction,
  IPollingTaskData,
  PollingTaskStatus,
} from '../types/polling'
import { trace } from '../services/common'
import { safeGet } from '../services/http'
import { POLLING_TIMEOUT } from '../config/file-upload'

export function* dataPollingSaga(action: IDataPollingAction) {
  try {
    yield delay(2000)
    const taskData: IPollingTaskData = yield call(safeGet, action.location)
    if (taskData.status === PollingTaskStatus.Failed) {
      yield put(
        action.failureAction(taskData.errorDescription, taskData.correlationId)
      )
    } else if (
      taskData.status === PollingTaskStatus.Completed ||
      taskData.status === PollingTaskStatus.Verified
    ) {
      yield put(action.successAction(taskData))
    } else if (Date.now() - action.startTime > POLLING_TIMEOUT) {
      // Since this is a timeout error & there's no `correlationId`, so we put it the empty string
      yield put(
        action.failureAction(
          'Something went wrong. Please, try to do again',
          ''
        )
      )
    } else {
      yield put(action)
    }
  } catch (err) {
    trace(err)
    yield put(action.failureAction(err.message, err.correlationId))
  }
}

export function* pollingWatcher() {
  yield takeEvery(types.DATA_POLLING__STARTED, dataPollingSaga)
}
